import { render } from "./Renewal.vue?vue&type=template&id=4f931bc3&scoped=true"
import script from "./Renewal.vue?vue&type=script&lang=js"
export * from "./Renewal.vue?vue&type=script&lang=js"

import "./Renewal.vue?vue&type=style&index=0&id=4f931bc3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f931bc3"]])

export default __exports__